import React, { useState, useEffect } from 'react';
import auctionService from '../services/auctionService';
import { formatCurrency, formatDate } from '../utils/validators';
import './Payouts.css';

const Payouts = () => {
  const [payouts, setPayouts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPayouts = async () => {
      const result = await auctionService.getPayouts();
      if (result.success) {
        setPayouts(result.data.payouts || []);
      }
      setLoading(false);
    };

    fetchPayouts();
  }, []);

  const totalEarnings = payouts.reduce((sum, p) => sum + (p.amount || 0), 0);

  return (
    <div className="container py-4">
      <h1>Payout History</h1>

      <div className="grid grid-3">
        <div className="stat-card">
          <div className="stat-label">Total Earnings</div>
          <div className="stat-value">{formatCurrency(totalEarnings)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Completed Payouts</div>
          <div className="stat-value">
            {payouts.filter(p => p.status === 'completed').length}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Pending Payouts</div>
          <div className="stat-value">
            {payouts.filter(p => p.status === 'pending').length}
          </div>
        </div>
      </div>

      <div className="card mt-3">
        {loading ? (
          <div className="spinner"><div className="loading"></div>Loading...</div>
        ) : payouts.length === 0 ? (
          <div className="empty-state"><p>No payouts yet</p></div>
        ) : (
          <div className="payouts-table">
            <table>
              <thead>
                <tr>
                  <th>Auction</th>
                  <th>Amount</th>
                  <th>Fee</th>
                  <th>Net Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {payouts.map((payout) => (
                  <tr key={payout.id}>
                    <td>
                      <strong>{payout.auctionTitle}</strong>
                    </td>
                    <td>{formatCurrency(payout.amount)}</td>
                    <td>{formatCurrency(payout.fee || 0)}</td>
                    <td>
                      <strong>{formatCurrency(payout.netAmount)}</strong>
                    </td>
                    <td>
                      <span className={`badge badge-${payout.status === 'completed' ? 'success' : 'warning'}`}>
                        {payout.status}
                      </span>
                    </td>
                    <td>{formatDate(payout.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="card mt-3">
        <h3>Bank Account</h3>
        <div className="bank-info">
          <p><strong>Account Holder:</strong> Your Company</p>
          <p><strong>Bank:</strong> **** **** **** 1234</p>
          <p><strong>Status:</strong> <span className="badge badge-success">Verified</span></p>
        </div>
      </div>
    </div>
  );
};

export default Payouts;
